var redirectUrls = require('../utils/redirect-urls')

module.exports = Em.Route.extend({
    beforeModel: function(transition) {
        return this.handleSignupRedirect(transition)
    },

    activate: function() {
        this._super.apply(this, arguments)
    },

    setupController: function(controller) {
        this._super(controller)
    },

    handleSignupRedirect: function(transition) {
        // Internal flows (existing users adding orgs) should not be redirected to the
        // external signup page — the in-app guide handles creation for them.
        var isInternalFlow = transition && transition.queryParams && transition.queryParams.isInternalFlow
        if (isInternalFlow) {
            return Em.RSVP.resolve()
        }

        var signupUrl = redirectUrls.getSignupRedirectUrl()

        if (signupUrl) {
            window.location.href = signupUrl
            return new Em.RSVP.Promise(function() {}) // Return pending promise to halt route
        } else {
            return Em.RSVP.resolve() // Continue with route
        }
    }
})
